export default __webpack_public_path__ + "static/media/star5.4a61306a.mp3";